import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initializeGA = () => {
  const id = process.env.REACT_APP_GA_ID;
  if (!id) return;
  const isProd = process.env.NODE_ENV === 'production';
  const debug = process.env.REACT_APP_GA_DEBUG === 'true';
  if (!isProd && !debug) return;
  ReactGA.initialize(id, { debug });
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
  });
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track user engagement (scroll depth, time on page, etc.)
export const trackTiming = (category, variable, time, label) => {
  ReactGA.event({
    category,
    action: variable,
    value: time,
    label,
  });
};

export default {
  initializeGA, trackPageView, trackEvent, trackTiming,
};
